
import React, { useState, useEffect } from "react";
import {
    Megaphone,
    Users,
    Tag,
    PartyPopper,
    Bell,
    Star,
    MessageCircle,
    RefreshCw,
    Calendar,
    TrendingUp,
    DollarSign,
    Percent,
    Gift,
    Clock,
    Truck,
    Zap,
    Download,
    QrCode,
    Grid3x3,
    ShoppingBag,
    Sparkles,
    ArrowLeft,
} from "lucide-react";

import "./PromotionFeatures.css";
import Createcampaignfirst from "./Createcampaignfirst.jsx";


const featureData = [
    {
        id: 1,
        title: "Branding Campaigns",
        description: "Build awareness across the app.",
        icon: <Megaphone />,
        color: "orange",
        goal: "branding",
        subGoal: "awareness",
    },
    {
        id: 2,
        title: "Lead Generation",
        description: "Capture warm customers daily.",
        icon: <Users />,
        color: "blue",
        goal: "leads",
        subGoal: "more_leads",
    },

    {
        id: 3,
        title: "Digital Branding",
        description: "Capture warm customers daily.",
        icon: <Users />,
        color: "blue",
        goal: "branding",
        subGoal: "awareness",
    },
    {
        id: 4,
        title: "WhatsApp Promotions",
        description: "Direct chat campaigns.",
        icon: <MessageCircle />,
        color: "green",
        goal: "leads",
        subGoal: "whatsapp_messages",
    },

    {
        id: 5,
        title: "Percentage Discount",
        description: "Launch percentage-based offers.",
        icon: <Percent />,
        color: "green",
        goal: "discount",
        subGoal: "menu",
    },
    {
        id: 6,
        title: "Flat Discount",
        description: "Offer flat discounts on orders.",
        icon: <DollarSign />,
        color: "orange",
        goal: "discount",
        subGoal: "coupons",
    },
    {
        id: 7,
        title: "Buy 1 Get 1",
        description: "Create attractive BOGO offers.",
        icon: <Gift />,
        color: "blue",
        goal: "BOGO_DISCOUNT",
        subGoal: "menu",
    },
    {
        id: 8,
        title: "Combo Offers",
        description: "Promote combo meals and bundles.",
        icon: <ShoppingBag />,
        color: "green",
        goal: "Combos",
        subGoal: "offers",
    },
    // {
    //     id: 9,
    //     title: "Festival Offers",
    //     description: "Run special festive promotions.",
    //     icon: <Calendar />,
    //     color: "orange",
    //     goal: "discount",
    //     subGoal: "coupons",
    // },
    {
        id: 8,
        title: "Happy Hours",
        description: "Create time-based discounts.",
        icon: <Clock />,
        color: "blue",
        goal: "discount",
        subGoal: "coupons",
    },

    // {
    //     id: 11,
    //     title: "Push Notifications",
    //     description: "Re-engage instantly.",
    //     icon: <Bell />,
    //     color: "blue",
    //     goal: "branding",
    //     subGoal: "recall",
    // },

];


const CreateCampaign = ({
    selectedPlan,
    selectedFeature,
    onBack,
    onNavigate,
}) => {// 👈 Accept onNavigate prop all the data 
    const [showCampaignBuilder, setShowCampaignBuilder] = useState(false);
    const [feature, setFeature] = useState(null);

    useEffect(() => {
        if (selectedFeature) {
            setFeature(selectedFeature);
            setShowCampaignBuilder(true);
        }
    }, [selectedFeature]);
    const handleExploreClick = (e, navigateTo) => {
        e.preventDefault(); // Prevent default anchor behavior
        if (onNavigate && navigateTo) {
            onNavigate(navigateTo);
        }
    };



    return (

        <>
            {showCampaignBuilder ? (

                <Createcampaignfirst
                    selectedPlan={selectedPlan}
                    selectedFeature={feature}
                    onBack={() => {
                        setShowCampaignBuilder(false);
                    }}
                />

            ) : (

                <section className="promo-features-root">

                    <div className="promo-features-container">

                        <div className="promo-features-grid">

                            {featureData.map((item) => (

                                <div
                                    key={item.id}
                                    className={`promo-feature-card promo-feature-card--${item.color}`}
                                >

                                    <div className="promo-feature-icon">
                                        {item.icon}
                                    </div>

                                    <div className="promo-feature-content">

                                        <h3 className="promo-feature-title">
                                            {item.title}
                                        </h3>

                                        <p className="promo-feature-desc">
                                            {item.description}
                                        </p>

                                        <button
                                            type="button"
                                            className="promo-feature-link"
                                            onClick={() => {


                                                const feature = {
                                                    id: item.id,
                                                    title: item.title,
                                                    goal: item.goal,
                                                    subGoal: item.subGoal,
                                                };


                                                setFeature(feature);
                                                setShowCampaignBuilder(true);
                                            }}
                                        >
                                            Explore →
                                        </button>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </section>

            )}
        </>

    );
};

export default CreateCampaign;